<template>
	<div class="login container">
		<div class="card darken-3 center-align">
			<div class="row">
				<h3 class="card-content teal-text">Login</h3>
			</div>
			<div class="card-content">
				<form class="col s12">
					<div class="row">
						<div class="input-field col s6">
							<i class="material-icons prefix">email</i>
							<input type="email" id="email" class="validate" v-model="email" />
							<label for="email">E-mail</label>
							<span class="helper-text left" data-error="Wrong format"></span>
						</div>
						<div class="input-field col s6">
							<i class="material-icons prefix">vpn_key</i>
							<input id="password" type="password" class="validate" v-model="password" />
							<label for="password">Password</label>
						</div>
					</div>
					<div v-if="feedback" class="row">
						<span class="red-text">{{ feedback }}</span>
					</div>
					<div class="row">
						<div class="btn waves-effect waves-light" @click="login">
							Submit
							<i class="material-icons right">send</i>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase'

export default {
	name: "Login",
	data() {
		return {
			email: null,
			password: null,
			feedback: null
		}
	},
	methods: {
		login() {
			if (!this.email || !this.password) {
				this.feedback = "You must fill in all fields!"
				return
			}

			firebase.auth().signInWithEmailAndPassword(this.email, this.password)
				.then(cred => this.$router.push({ name: "Index" }))
				.catch(err => this.feedback = err)
		}
	}
}
</script>

<style>
.login {
	max-width: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/auth/Login.vue